import React, {useEffect, useState} from 'react';
import {getListings} from '../../Actions/getListings';
import {getThumbnailImage} from '../../HelperClasses/SingletonClass';
import SaveButton from '../../Component/SaveButton';
import SecondryButton from '../../Component/SecondryButton';
import {onAddToCart} from './Actions/OnAddToCart';
import {onFetchCart} from './Actions/OnFetchCart';
import SearchListing from './SearchListing';
import AppLoader from '../../HelperClasses/AppLoaderClasses/AppLoader';

const ListingSelection = ({
  current_step,
  setCurrentStep,
  selectedUser,
  fullCartInfo,
  setFullCartInfo,
  setIsLoading,
  pk_key,
}) => {
  const [listings, setListings] = useState(null);
  const [page, setPage] = useState(1);
  const [total_records, setTotalRecords] = useState(0);
  const [isListingLoading, setIsListingLoading] = useState(false);

  // get listings
  useEffect(() => {
    getListings({page: 1, setIsListingLoading}).then(listings => {
      setListings(listings.listings);
      setTotalRecords(listings.total_records);
      setPage(1);
    });
  }, []);

  // fetch cart
  useEffect(() => {
    if (selectedUser) {
      onFetchCart({setFullCartInfo, setIsLoading, selectedUser, pk_key});
    }
  }, [selectedUser]);

  const handleSearch = search => {
    getListings({page: 1, search, setIsListingLoading}).then(listings => {
      setListings(listings.listings);
      setTotalRecords(listings.total_records);
      setPage(1);
    });
  };

  return (
    <>
      {/*  */}
      <SearchListing handleSearch={handleSearch} />
      {/*  */}
      <div className=" flex-1  max-h-[10%]  flex flex-col gap-3   overflow-y-auto border border-gray-200 rounded-md py-4 px-5  w-[97%] md:w-[95%]   mx-auto">
        <div>
          <h1 className="text-lg font-medium">Listings</h1>
        </div>
        <div className="flex flex-col gap-4">
          {listings?.map(listing => (
            <div
              key={listing.id}
              className="flex flex-row gap-2 border rounded-md p-2">
              <img
                src={
                  listing.images[0] ? getThumbnailImage(listing.images[0]) : ''
                }
                alt={listing.title}
                className="h-[100px] w-[100px] object-cover rounded-md"
              />
              <div className="flex flex-col w-full">
                <h1 className=" text-lg font-medium">{listing.title}</h1>
                <p className=" text-sm font-normal line-clamp-2">
                  {listing.description}
                </p>
                <div className="flex flex-row gap-2 items-center justify-between mt-2">
                  <p className=" text-sm font-medium text-primary">
                    {listing.offer_price?.formatted}
                  </p>

                  <SaveButton
                    saveBtnTitle="Add to Cart"
                    saveBtn={() => {
                      onAddToCart({
                        listing,
                        setFullCartInfo,
                        setIsLoading,
                        selectedUser,
                        pk_key,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <AppLoader enable={isListingLoading ? false : true} />
      </div>
    </>
  );
};

export default ListingSelection;
